export class Point {
	private _x: number;
	get x() {
		return this._x;
	}

	set x(val) {
		val = Math.abs(val) < 0.0001 ? 0 : val;
		this._x = val;
	}

	_y: number;
	get y() {
		return this._y;
	}

	set y(val) {
		val = Math.abs(val) < 0.0001 ? 0 : val;
		this._y = val;
	}

	get height(): number {
		return this.y;
	}

	get width(): number {
		return this.x;
	}

	/**
	 * Ratio of the point X:Y
	 */
	get ratio() {
		return this.x / this.y;
	}

	constructor(x: number, y: number) {
		this.x = x;
		this.y = y;
	}

	static make(val: number) {
		return new Point(val, val);
	}

	get half() {
		return this.dived(2);
	}

	//Return point changed by number
	plus(val: number): Point {
		return new Point(this.x + val, this.y + val);
	}

	multed(val: number): Point {
		return new Point(this.x * val, this.y * val);
	}

	dived(val: number): Point {
		return new Point(this.x / val, this.y / val);
	}

	//Return point changed by point
	plusP(other: Point): Point {
		return new Point(this.x + other.x, this.y + other.y);
	}

	minusP(other: Point): Point {
		return new Point(this.x - other.x, this.y - other.y);
	}

	multedP(other: Point): Point {
		return new Point(this.x * other.x, this.y * other.y);
	}

	divedP(other: Point): Point {
		return new Point(this.x / other.x, this.y / other.y);
	}
}
